import { render, staticRenderFns } from "./fMenu.template?vue&type=template&id=79722b02&lang=pug&"
import script from "./fMenu.client?vue&type=script&lang=ts&"
export * from "./fMenu.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79722b02')) {
      api.createRecord('79722b02', component.options)
    } else {
      api.reload('79722b02', component.options)
    }
    module.hot.accept("./fMenu.template?vue&type=template&id=79722b02&lang=pug&", function () {
      api.rerender('79722b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fMenu/fMenu.component.vue"
export default component.exports